
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/bundle",
      function () {
        return require("private-next-pages/bundle/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/bundle"])
      });
    }
  